import { Injectable, OnDestroy } from '@angular/core';
import { Subject, BehaviorSubject, fromEvent } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { Router } from '@angular/router';
// Menu
export interface Menu {
  headTitle?: string;
  headTitle2?: string;
  path?: string;
  title?: string;
  icon?: string;
  type?: string;
  badgeValue?: string;
  badgeClass?: string;
  badgeText?: string;
  active?: boolean;
  selected?: boolean;
  bookmark?: boolean;
  children?: Menu[];
  children2?: Menu[];
  Menusub?: boolean;
  target?: boolean;
  menutype?: string;
  menuName?: string;
  separator?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class NavService implements OnDestroy {
  private unsubscriber: Subject<any> = new Subject();
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(
    window.innerWidth
  ); 

  // Search Box
  public search = false;

  // Language
  public language = false;

  // Mega Menu
  public megaMenu = false;
  public levelMenu = false;
  public megaMenuColapse: boolean = window.innerWidth < 1199 ? true : false;

  // Collapse Sidebar
  public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

  // For Horizontal Layout Mobile
  public horizontal: boolean = window.innerWidth < 991 ? false : true;

  // Full screen
  public fullScreen = false;
  active: any;

  constructor(private router: Router) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, 'resize')
      .pipe(debounceTime(1100), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 991) {
          this.collapseSidebar = true;
          this.megaMenu = false;
          this.levelMenu = false;
        }
        if (evt.target.innerWidth < 1199) {
          this.megaMenuColapse = true;
        }
      });
    if (window.innerWidth < 991) {
      // Detect Route change sidebar close
      this.router.events.subscribe((event) => {
        this.collapseSidebar = true;
        this.megaMenu = false;
        this.levelMenu = false;
      });
    }
  }

  ngOnDestroy() {
    this.unsubscriber.next;
    this.unsubscriber.complete();
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  private filterMenuItems(menuItems: Menu[], allowedMenus: string[]): Menu[] {
    return menuItems
      .map(menu => {
        const isAllowed = allowedMenus.includes(menu.menuName || '');
        const filteredChildren = menu.children 
          ? this.filterMenuItems(menu.children, allowedMenus) 
          : [];

        if (isAllowed || filteredChildren.length > 0 || menu.headTitle) {
          return {
            ...menu,
            children: filteredChildren.length > 0 ? filteredChildren : undefined
          };
        }
        return null;
      })
      .filter(menu => menu !== null) as Menu[];
  }

  MENUITEMS: Menu[] = [
    {
      title: 'MENU.HOME',
      icon: 'home',
      type: 'link',
      path: '/home',
      menuName: '5000',
    },
    {
      title: 'MENU.DASHBOARD',
      icon: 'grid-alt',
      type: 'link',
      path: '/dashboardpage',
      menuName: '5010',
    },
    {
      title: 'MENU.POS_PAYMENTS.POS_PAYMENT',
      icon: 'wallet',
      type: 'sub',
      children: [
        {
          title: 'MENU.POS_PAYMENTS.ALL_SERVICE',
          path: '/dashboard/epos-payments/all',
          type: 'link',
          menuName: '5020',
        },
        {
          title: 'MENU.POS_PAYMENTS.BASIC',
          path: '/dashboard/epos-payments/basic',
          type: 'link',
          menuName: '5021',
        },
        {
          title: 'MENU.POS_PAYMENTS.BILL_PAYMENT',
          path: '/dashboard/epos-payments/bill',
          type: 'link',
          menuName: '5022',
        },
      ],
    },
    {
      title: 'MENU.TRANSACTIONS.TRANSACTIONS',
      icon: 'transfer',
      type: 'sub',
      children: [
        {
          title: 'MENU.TRANSACTIONS.AGENT_TELLER',
          path: 'transact/account-journal/agent-transactions',
          type: 'link',
          menuName: '5030',
        },
        {
          title: 'MENU.TRANSACTIONS.NETWORK_TRANSACTION',
          path: 'transact/account-journal/network-transactions',
          type: 'link',
          menuName: '5031',
        },
        {
          title: 'MENU.TRANSACTIONS.NETWORK_BALANCE',
          path: 'transact/account-journal/network-balance',
          type: 'link',
          menuName: '5032',
        },
      ],
    },
    {
      title: 'MENU.COMMISSIONS.COMMISSIONS',
      icon: 'money-withdraw',
      type: 'sub',
      children: [
        {
          title: 'MENU.COMMISSIONS.AGENT_COMMISSION',
          path: '/commission/agent',
          type: 'link',
          menuName: '5050',
        },
        {
          title: 'MENU.COMMISSIONS.NETWORK_COMMISSION',
          path: '/commission/network/list',
          type: 'link',
          menuName: '5051',
        },
        {
          title: 'MENU.COMMISSIONS.PAID_OUT_COMMISSION',
          path: '/commission/paid-commission',
          type: 'link',
          menuName: '5052',
        },
      ],
    },
    { headTitle: 'MENU.STATEMENTS' },
    {
      title: 'MENU.ANALYTICS.ANALYTICS',
      icon: 'bar-chart-alt-2',
      type: 'sub',
      children: [
        {
          title: 'MENU.ANALYTICS.AGENT_TELLER',
          path: '/analytics/agent-transaction',
          type: 'link',
          menuName: '5075',
        },
        {
          title: 'MENU.ANALYTICS.NETWORK',
          path: '/analytics/network-transaction',
          type: 'link',
          menuName: '5076',
        },
      ],
    },
    {
      title: 'MENU.BALANCE_SHEET',
      icon: 'detail',
      type: 'link',
      path: '/account/balance-sheet',
      menuName: '5080',
    },
    {
      title: 'MENU.MONTHLY_STATEMENT',
      icon: 'calendar',
      type: 'link',
      path: '/monthly-statement',
      menuName: '5085',
    },
    { headTitle: 'MENU.OTHERS' },
    {
      title: 'MENU.FLOAT_REQUEST',
      icon: 'transfer-alt',
      type: 'link',
      path: '/float-request-history',
      menuName: '5090',
    },
    {
      title: 'MENU.MASS_PAYMENTS',
      icon: 'transfer-alt',
      type: 'link',
      path: 'transact/bulk-credit-list',
      menuName: '5091',
    },
    {
      title: 'MENU.REPRINT_RECEIPTS',
      icon: 'receipt',
      type: 'link',
      path: '/reprint',
      menuName: '5092',
    },
    {
      title: 'MENU.AGENT_APKS',
      icon: 'receipt',
      type: 'link',
      path: '/agent-apk',
      menuName: '5092',
    },
  ];
  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);

  public loadMenu(allowedMenus: string[]) {
    const filtered = this.filterMenuItems(this.MENUITEMS, allowedMenus);
    this.items.next(filtered);
  }
}
